export const bicycles = [
    {
      id: 1,
      name: "Kryo X26 MTB - Model K",
      price: 350.0,
      image: "/assets/k.webp",
      rating: 5,
      description:
      "The Kryo X26 MTB is a high-performance mountain bike designed for the most challenging terrains. With its lightweight frame and advanced suspension system, it offers superior control and comfort on any trail.",
    specs: [
      'Lightweight 18" Frame',
      "Steel Suspension Fork",
      "Steel Hardtail Frame",
      "21-Speed Shimano Gears",
      "Disc Brakes",
      '26" Wheels',
    ]
    },
    {
      id: 2,
      name: "Kryo X26 MTB - Model X",
      price: 350.0,
      image: "/assets/x.webp",
      rating: 4,
      description:
      "The Kryo X26 MTB is a high-performance mountain bike designed for the most challenging terrains. With its lightweight frame and advanced suspension system, it offers superior control and comfort on any trail.",
    specs: [
      'Lightweight 18" Frame',
      "Steel Suspension Fork",
      "Steel Hardtail Frame",
      "21-Speed Shimano Gears",
      "Disc Brakes",
      '26" Wheels',
    ]
    },
    {
      id: 3,
      name: "Kryo X26 MTB - Model Y",
      price: 350.0,
      image: "/assets/y.webp",
      rating: 5,
      description:
      "The Kryo X26 MTB is a high-performance mountain bike designed for the most challenging terrains. With its lightweight frame and advanced suspension system, it offers superior control and comfort on any trail.",
    specs: [
      'Lightweight 18" Frame',
      "Steel Suspension Fork",
      "Steel Hardtail Frame",
      "21-Speed Shimano Gears",
      "Disc Brakes",
      '26" Wheels',
    ]
    },
    {
      id: 4,
      name: "Kryo X26 MTB - Model Z",
      price: 350.0,
      image: "/assets/z.webp",
      rating: 4,
      description:
      "The Kryo X26 MTB is a high-performance mountain bike designed for the most challenging terrains. With its lightweight frame and advanced suspension system, it offers superior control and comfort on any trail.",
    specs: [
      'Lightweight 18" Frame',
      "Steel Suspension Fork",
      "Steel Hardtail Frame",
      "21-Speed Shimano Gears",
      "Disc Brakes",
      '26" Wheels',
    ]
    },
    
  ];
